<template>
  <div :class="$options.name">
    <v-menu
      :close-on-click="true"
      :close-on-content-click="true"
      content-class="my-custom-dialog"
      max-height="350"
    >
      <template v-slot:activator="{ on }">
        <v-btn min-width="29" height="29" class="pa-0" v-on="on">
          <v-icon small>layers</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item) in list"
          :key="item.key"
          :class="{ 'v-list-item--active': (item.key === currentMapStyle) }"
          @click="$emit('change-map-style', item)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'custom-menu',
  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
    currentMapStyle: {
      type: String,
      default: 'default',
    },
  },

  data: () => ({
    location: 'end',
  }),
};
</script>

<style lang="scss">
.custom-menu {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  margin: 0 0 10px 10px;
}

.my-custom-dialog {
  transform: translate(0px, calc(29px - 100%));
}
</style>
